module.exports = __webpack_public_path__ + "img/follow_3.63e1a86d.png";